export const pad = (string: string, length = 255) => string.length > length ? `${string.substring(0, length - 3)}...` : string

//generates unique id
export const uid = function(){
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
}
